import script from "./newMediaTwo.vue?vue&type=script&setup=true&lang=ts"
export * from "./newMediaTwo.vue?vue&type=script&setup=true&lang=ts"

import "./newMediaTwo.vue?vue&type=style&index=0&id=6ea671ca&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea671ca"]])

export default __exports__